module.exports = __webpack_public_path__ + "img/product5@2x.b0bd2559.png";